<template>
    <div>
        <v-dialog
    v-model="add_partner_dialog"
    max-width="450"
    @click:outside="close_partner"
  >
    <v-card>

    <v-toolbar
        color="primary"
        dark
        >
        <v-toolbar-title>Добавление нового партнера</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
        <v-btn icon dark @click="close_partner">
            <v-icon>mdi-close</v-icon>
        </v-btn>
        </v-toolbar-items>
    </v-toolbar>

<v-form ref="forma" v-model="valid">
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="forma.nom_partner"
                label="Имя партнера"
                required
                :rules="[v => !!v || 'Введите имя партнера']"
                @focus="scanner()"
                @blur="scanner()"
                hide-details="auto"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="forma.tel"
                label="Телефон клиента"
                required
                :rules="phoneRules"
                @focus="scanner()"
                @blur="scanner()"
                hide-details="auto"
              ></v-text-field>
            </v-col>




            <v-col cols="12">
                <v-text-field
                @focus="scanner()"
                @blur="scanner()"
                v-model="forma.nomer_karta"
                label="Номер партнёрская карта"
                required
                :rules="[v => !!v || 'Введите номер партнёрская карта']"
                hide-details="auto"
                ></v-text-field>
            </v-col>

            <v-col cols="12">
                <!-- button save -->
                <v-btn
                block
                color="primary"
                class="mr-4"
                @click="save_partner"
                :loading="loading"
                :disabled="!valid"
                >
                Сохранить
                </v-btn>

            </v-col>



          </v-row>
        </v-container>
      </v-card-text>
    </v-form>

      <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>

    </v-card>
  </v-dialog>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            loading: false,
            valid:false,
            snack: false,
            snackColor: '',
            snackText: '',

            add_partner_dialog: true,

            activePicker: null,

            menu: false,

              phoneRules: [
                v => !!v || 'Введите номер телефона',
                v => (v && /^\d+$/.test(v)) || 'Неверный формат номера телефона',
                v => (v && v.length == 9) || 'Неверный формат номера телефона',
            ],



            forma:{
                nom_partner: '',
                tel:'',
                nomer_karta: '',

            }

        }
    },

    watch: {

    },

    methods: {
        addKlent() {
            this.add_partner_dialog = true;
        },



        scanner(){
            this.$emit('scanner')
        },


        save_partner(){
            this.loading = true;
            axios.post('/api/save_partner', this.forma,
            {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'success'
                        this.snackText = response.data.message
                        this.forma = {}
                        setTimeout(() => {
                            this.snack = false;
                        }, 2000);

                        this.$emit('save_partner_success')

                    }else{
                        this.loading = false;

                        setTimeout(() => {
                            this.snack = false;
                        }, 2000);
                    }
                })
                .catch(error => {
                    this.loading = false;

                    this.$emit('save_partner_error')
                    this.snack = true
                    this.snackColor = 'error'
                    this.snackText = error.response.data.message

                        setTimeout(() => {
                            this.snack = false;
                        }, 2000);
                });

        },

        close_partner(){
            this.$emit('close_partner')
        }
    }

}
</script>

<style>

</style>








